import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { Box, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select } from "@mui/material"
import { setFromEvent } from "lib/setFromEvent"
import { DATE_FORMATS } from "lib/@constants/date-format"
import { useState } from "react"
import Iconify from "minimals-template/components/Iconify"
import { confirm } from "lib/@dialogs/confirm"
import { ExistingMappingRemoved, ExistingMappingSelected } from "event-definitions"

export function ChooseMapping({ mappings }) {
    const [hover, setHover] = useState(false)
    const [fields, setFields] = useBoundValue("fields")
    const [existingMapping, setExistingMapping] = useBoundValue("existingMapping", null)
    const mappingValue = mappings.some((m) => m.name === existingMapping?.name) ? existingMapping.name : ""

    return (
        <Box sx={{ pt: 2 }}>
            <FormControl fullWidth>
                <InputLabel id="previous-mapping-select-label">Select previous mapping template</InputLabel>
                <Select
                    labelId="previous-mapping-select-label"
                    value={mappingValue}
                    label="Select previous mapping template"
                    onChange={setFromEvent(handleSelectMapping)}
                    onMouseEnter={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                    data-cy="asset-import-previous-mapping-select"
                    endAdornment={
                        mappingValue &&
                        hover && (
                            <InputAdornment sx={{ position: "absolute", right: 30 }} position="end">
                                <IconButton
                                    aria-label="Clear mapping"
                                    size="small"
                                    edge="end"
                                    onClick={handleClear}
                                    data-cy="asset-import-previous-mapping-clear"
                                >
                                    <Iconify icon={"ic:round-clear"} />
                                </IconButton>
                            </InputAdornment>
                        )
                    }
                >
                    {mappings.length > 0 ? (
                        mappings.map((mapping, index) => (
                            <MenuItem
                                key={index}
                                value={mapping.name}
                                data-cy={`asset-import-previous-mapping-select-option-${index}`}
                            >
                                {mapping.name} - (Saved {new Date(mapping.created).format(DATE_FORMATS.mediumSlash)})
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem value="">
                            <em>No previous mapping templates</em>
                        </MenuItem>
                    )}
                </Select>
            </FormControl>
        </Box>
    )

    async function handleSelectMapping(value) {
        if (
            await confirm(
                "This will set the fields based on the selected mapping template, are you sure?",
                "Select Previous Mapping"
            )
        ) {
            const mapping = mappings.find((option) => option.name === value)
            if (mapping) {
                setExistingMapping(mapping)
                setFields(structuredClone(mapping.mapping))
                ExistingMappingSelected.raise({ mappings: mapping.mapping })
            }
        }
    }

    async function handleClear(event) {
        event.stopPropagation()
        if (
            await confirm(
                "This will clear fields that exist in the selected mapping template, are you sure?",
                "Clear Previous Mapping"
            )
        ) {
            setExistingMapping(null)
            const updatedFields = Object.fromEntries(
                Object.entries(fields).filter(([key]) => !existingMapping.mapping[key])
            )
            setFields(updatedFields)
            ExistingMappingRemoved.raise({ mappings: existingMapping.mapping })
        }
    }
}
